module.exports = __webpack_public_path__ + "img/flowPath-item5-off.5624af47.png";